var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM13.7056 9.92044C14.3344 10.4429 14.9797 10.9789 15.3044 11.8227C15.9052 13.2604 15.4975 14.9127 14.3817 15.9481C13.3678 16.8762 11.9569 17.1176 10.6533 16.9513C9.7413 16.8333 7.20385 15.9105 7 12.9064C7 11.5491 7.37016 10.6479 7.73495 10.09C7.89052 9.8593 8.25531 9.99342 8.22312 10.2724C8.13729 11.0288 8.23922 12.0856 9.21021 12.8205C9.41942 12.9815 9.70911 12.7508 9.61255 12.504C8.43771 9.48915 9.83786 7.18774 11.7852 6.03972C11.9891 5.91634 12.2412 6.09873 12.1875 6.33477C11.7425 8.28955 12.7033 9.08772 13.7056 9.92044ZM11.6028 13.2819C11.4955 13.7754 11.0985 14.3334 10.326 14.5211C11.8818 15.7979 13.3517 14.6338 13.3087 13.2765C13.3087 12.6909 12.8571 12.239 12.4101 11.7916C12.0217 11.4029 11.6368 11.0177 11.5545 10.5513C11.2782 11.2691 11.408 11.8251 11.5232 12.3185C11.6026 12.6586 11.675 12.9689 11.6028 13.2819Z",
    fill: "#F58025"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeating);
export default __webpack_public_path__ + "static/media/heating.b2a174a13d9058ae0a7338336c36743b.svg";
export { ForwardRef as ReactComponent };